import React, { MouseEvent, useCallback } from 'react';

import { Box, Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { DataGrid, GRID_CHECKBOX_SELECTION_COL_DEF, GridColDef } from '@mui/x-data-grid';
import { GridRowSelectionModel } from '@mui/x-data-grid-pro';

import { ManualExperienceLocation, defaultColumns } from '~/components/Content/ManualExperienceLocations/Columns';

interface Props {
  data: Array<ManualExperienceLocation>;
  isLoading: boolean;
  selected: GridRowSelectionModel;
  handleSelect: (selectedIds: GridRowSelectionModel) => void;
  handleDelete: (event: MouseEvent<HTMLButtonElement>) => void;
}

function ManualExperienceLocationTable({ data, isLoading, handleSelect, selected, handleDelete }: Props) {
  const columns: Array<GridColDef<ManualExperienceLocation>> = [
    ...defaultColumns,
    {
      ...GRID_CHECKBOX_SELECTION_COL_DEF,
      width: 100,
    },
  ];

  const handleBulkDelete = useCallback(
    (event) => {
      event.preventDefault();
      handleDelete(event);
    },
    [handleDelete],
  );

  return (
    <Box mt={2}>
      <Grid size={4}>
        <Button disabled={selected.length === 0} onClick={handleBulkDelete} color="error">
          Remove Selected Associations
        </Button>
      </Grid>

      <DataGrid
        columns={columns}
        checkboxSelection
        className="T-experience-locations-table"
        rows={data || []}
        loading={isLoading}
        getRowId={(row: {
          experienceOfferId: string;
          experienceOfferName: string;
          placeName: string;
          placeId: string;
          comments: string;
          addedBy: string;
          createdAt: string;
          id: string;
        }) => row.id}
        getRowHeight={() => 'auto'}
        onRowSelectionModelChange={handleSelect}
        rowSelectionModel={selected}
        disableRowSelectionOnClick
        disableColumnMenu
        autoHeight
      />
    </Box>
  );
}

export default ManualExperienceLocationTable;
